module.exports = __webpack_public_path__ + "media/images/jane_background-1825c0154eba6ab4a78997d0bab6e94e.svg";